import React from "react";

export default function NotFound() {
    return (
        <div>
            <div className={"main"}>
                <div className={"full-container con-mid"}>
                    404 - Not Found
                </div>
            </div>
        </div>
    );
}